trackView = (data, done) ->
  Application.publish("event:view") data

trackInteraction = (data) ->
  Application.publish("event:interaction") data

trackEvent = ->
startTracking = ->
stopTracking = ->

commands = (next) ->
  { trackInteraction, trackView, startTracking, stopTracking, trackEvent }

module.exports = { type: "analytics", commands }

